export default __webpack_public_path__ + "static/media/mode-47.f0200f13.svg";